export default __webpack_public_path__ + "static/media/G0380.34I-26208_-16823_0.1666262400000.fd936b71.jpg";